import {Injectable} from "@angular/core";
import {Product} from "@app/core/product/domain/dtos/product";
import {PdfCatalogRepo} from "@app/core/pdf-catalog/domain/repositories/pdf-catalog.repo";

/**
 * Use case for adding a product to the PDF catalog.
 * This is part of a flow that allows products to be added so they can later be used to generate a PDF catalog with the added products.
 */
 @Injectable({
    providedIn: "root",
})

export class AddPdfCatalogProductUseCase {

    constructor(private pdfCatalogLocal: PdfCatalogRepo) {
    }

    execute(product: Product): void {
        this.pdfCatalogLocal.addProduct(product)
    }

}
